var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options),function(option,index){return _c('button',{key:index,staticClass:"button button--field",class:{active: _vm.value === option.value},on:{"click":function($event){return _vm.updateValue(option.value)}}},[_c('i',{class:[option.className, 'icon icon--button' ]}),_vm._v(_vm._s(option.name))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c5cff3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputChoice.vue
// module id = 433
// module chunks = 0